// Supervisor List (Collection Supervisors)
export const SUPERVISOR_USERS_REQUEST = 'SUPERVISOR_USERS_REQUEST';
export const SUPERVISOR_USERS_SUCCESS = 'SUPERVISOR_USERS_SUCCESS';
export const SUPERVISOR_USERS_FAIL = 'SUPERVISOR_USERS_FAIL';

// Supervisor Master List
export const SUPERVISOR_MASTER_LIST_REQUEST = 'SUPERVISOR_MASTER_LIST_REQUEST';
export const SUPERVISOR_MASTER_LIST_SUCCESS = 'SUPERVISOR_MASTER_LIST_SUCCESS';
export const SUPERVISOR_MASTER_LIST_FAIL = 'SUPERVISOR_MASTER_LIST_FAIL';

// Supervisor Master Create
export const SUPERVISOR_MASTER_CREATE_REQUEST = 'SUPERVISOR_MASTER_CREATE_REQUEST';
export const SUPERVISOR_MASTER_CREATE_SUCCESS = 'SUPERVISOR_MASTER_CREATE_SUCCESS';
export const SUPERVISOR_MASTER_CREATE_FAIL = 'SUPERVISOR_MASTER_CREATE_FAIL';
export const SUPERVISOR_MASTER_CREATE_RESET = 'SUPERVISOR_MASTER_CREATE_RESET';

// Supervisor Master Update
export const SUPERVISOR_MASTER_UPDATE_REQUEST = 'SUPERVISOR_MASTER_UPDATE_REQUEST';
export const SUPERVISOR_MASTER_UPDATE_SUCCESS = 'SUPERVISOR_MASTER_UPDATE_SUCCESS';
export const SUPERVISOR_MASTER_UPDATE_FAIL = 'SUPERVISOR_MASTER_UPDATE_FAIL';
export const SUPERVISOR_MASTER_UPDATE_RESET = 'SUPERVISOR_MASTER_UPDATE_RESET';

// Supervisor Master Delete
export const SUPERVISOR_MASTER_DELETE_REQUEST = 'SUPERVISOR_MASTER_DELETE_REQUEST';
export const SUPERVISOR_MASTER_DELETE_SUCCESS = 'SUPERVISOR_MASTER_DELETE_SUCCESS';
export const SUPERVISOR_MASTER_DELETE_FAIL = 'SUPERVISOR_MASTER_DELETE_FAIL';
export const SUPERVISOR_MASTER_DELETE_RESET = 'SUPERVISOR_MASTER_DELETE_RESET';

// Supervisor Master Upload
export const SUPERVISOR_MASTER_UPLOAD_REQUEST = 'SUPERVISOR_MASTER_UPLOAD_REQUEST';
export const SUPERVISOR_MASTER_UPLOAD_SUCCESS = 'SUPERVISOR_MASTER_UPLOAD_SUCCESS';
export const SUPERVISOR_MASTER_UPLOAD_FAIL = 'SUPERVISOR_MASTER_UPLOAD_FAIL';
export const SUPERVISOR_MASTER_UPLOAD_RESET = 'SUPERVISOR_MASTER_UPLOAD_RESET';
